<script setup>

const props = defineProps({
  isCurrent: Boolean,
  buttonText: String,
  path: String,
})

</script>
<template>
  <router-link class="inline-flex flex-col items-center justify-center px-1.5 hover:bg-gray-50 group "
    :class="props.isCurrent ? 'text-accent' : 'text-gray-500'" :to="props.path">
    <slot class="group-hover:text-accent">
    </slot>
    <span class="text-xs font-light group-hover:text-teal-400">
      {{ props.buttonText }}
    </span>
  </router-link>
</template>